import React from "react";
import "./Footer.css";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="Footer" aria-label="Site footer">
      <div className="Footer__container">
        {/* Quick Links */}
        <nav className="Footer__col" aria-labelledby="ft-quicklinks">
          <h3 id="ft-quicklinks" className="Footer__title">Quick Links</h3>
          <ul className="Footer__list">
            <li><a href="/">Home</a></li>
            <li><a href="/about">About</a></li>
            <li><a href="/how-it-works">How It Works</a></li>
            <li><a href="/Pricing">Pricing</a></li>
          </ul>
        </nav>

        {/* Support */}
        <nav className="Footer__col" aria-labelledby="ft-support">
          <h3 id="ft-support" className="Footer__title">Support</h3>
          <ul className="Footer__list">
            <li><a href="/contact">Contact</a></li>
            <li><a href="/terms">Terms &amp; Conditions</a></li>
            <li><a href="/privacy">Privacy Policy</a></li>
          </ul>
        </nav>

        {/* Contact Us */}
        <div className="Footer__col" aria-labelledby="ft-contact">
          <h3 id="ft-contact" className="Footer__title">Contact Us</h3>

          <address className="Footer__address">
    

            <div className="Footer__row">
              <span className="Footer__icon" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M3.75 4.167c.324-1.09 2.21-1.09 2.534 0l.53 1.782c.22.74-.113 1.554-.79 1.92l-.92.496a12.5 12.5 0 0 0 6.53 6.53l.496-.92c.366-.677 1.18-1.01 1.92-.79l1.782.53c1.09.324 1.09 2.21 0 2.534l-1.132.338c-.62.185-1.286.212-1.92.074-6.138-1.31-10.99-6.162-12.3-12.3-.138-.634-.11-1.3.074-1.92l.338-1.132z" fill="currentColor"/>
                </svg>
              </span>
              <a className="Footer__link" href="tel:+12536272663">253.359.7574</a>
            </div>

            <div className="Footer__row">
              <span className="Footer__icon" aria-hidden="true">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <path d="M2.5 5a1.667 1.667 0 0 1 1.667-1.667h11.666A1.667 1.667 0 0 1 17.5 5v10a1.667 1.667 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 15V5zm1.667 0l5.833 4.167L15.833 5H4.167zm11.666 10V7.5l-5.833 4.166L4.167 7.5V15h11.666z" fill="currentColor"/>
                </svg>
              </span>
              <a className="Footer__link" href="mailto:info@emrald.property">office@emeraldappraisalservices.com</a>
            </div>
          </address>
        </div>
      </div>

      <div className="Footer__bottom">
        <div className="Footer__bottom-container">
          <p className="Footer__copy">
            © {year} Emerald Appraisal Services. All rights reserved.{" "}
            <a className="Footer__credit" href="https://connectrader.com/">Site by connectrader</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
